import { useEffect, useRef } from 'react'

export default function MoveHistory({ moves }) {
  const bottomRef = useRef(null)
  const scrollRef = useRef(null)

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight
    }
  }, [moves])

  if (!moves.length) {
    return (
      <div className="flex-1 flex flex-col items-center justify-center p-6 opacity-30">
        <div className="w-8 h-[1px] bg-zinc-700 mb-4" />
        <p className="text-[10px] font-mono uppercase tracking-[0.2em] text-zinc-500">
          Waiting for Opening
        </p>
      </div>
    )
  }

  const pairs = []
  for (let i = 0; i < moves.length; i += 2) {
    pairs.push({
      white: moves[i],
      black: moves[i + 1] || null,
      num: Math.floor(i / 2) + 1,
    })
  }

  return (
    <div
      ref={scrollRef}
      className="flex-1 overflow-y-auto p-2 scrollbar-hide bg-black/20"
      style={{ maxHeight: 'calc(100vh - 240px)' }}
    >
      <div className="space-y-1">
        {pairs.map(({ white, black, num }) => (
          <div
            key={num}
            className="group flex items-center gap-2 rounded-md border border-transparent hover:border-white/5 hover:bg-zinc-900/50 transition-all px-2 py-1"
          >
            <span className="text-[10px] font-mono text-zinc-600 w-5 flex-shrink-0">
              {num.toString().padStart(2, '0')}
            </span>

            <div className="flex-1 flex items-center justify-between px-3 py-1.5 rounded bg-zinc-900/80 border border-white/5 group-hover:border-orange-500/20">
              <span className="text-xs font-bold font-mono text-zinc-100">
                {white?.san}
              </span>
              <div className="w-1 h-1 rounded-full bg-zinc-700" />
            </div>

            <div className={`flex-1 flex items-center justify-between px-3 py-1.5 rounded border ${
              black
                ? 'bg-zinc-800/40 border-white/5 group-hover:border-orange-500/20'
                : 'bg-transparent border-dashed border-white/5'
            }`}>
              <span className="text-xs font-bold font-mono text-orange-500">
                {black?.san || '•••'}
              </span>
              {black && <div className="w-1 h-1 rounded-full bg-orange-900" />}
            </div>
          </div>
        ))}
      </div>
      <div ref={bottomRef} />
    </div>
  )
}